export default {
    name: 'blogs',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-blogs',
            component: () => import('@/modules/blogs/view/Home.vue'),
        },
        {
            path: 'add',
            name: 'add-blogs',
            component: () => import('@/modules/blogs/view/Add.vue'),
            props: (route) => {
                return {
                    id: 'new'
                }
            }
        },
        {
            path: ':id',
            name: 'edit-blogs',
            component: () => import('@/modules/blogs/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]
}